import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import download from 'downloadjs'
import VueElementLoading from 'vue-element-loading';
import {
	Validator
} from 'vee-validate'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'Stockreport',
	components: {
		Paginate,
		download,
		DatePicker,
		JsonExcel,
		VueElementLoading
	},
	data: function() {
		return {
			//modalShow used for close the active/inactive modal(default)
			isLoadingforxls: false,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalRows:0,
			listStockData: [],
			listWarehouseData: [],
			listStockReportDatacsv: [],
			csvFields: [],
			pageno: 0,
			pageCount: 0,
			formattedDate: '',
			isLoading: false,
			clientproductid: '',
			productname: '',
			productmrp: '',
			Warehousestock: '',
			PromiseStock: '',
			UOM: '',
			lastupdated: '',
			formateddate: '',
			terms: false,
			resultCount: '',
			listClientData: [],

			ClientErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			searchFlag:false,
			user_type: '',

			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
		}
	},
	created: function() {},
	// when a page loads,mounted() will be call
	mounted() {
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.reportname = this.$t('editedjson.stockreportClient')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.getClientList();
				this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
	},
	methods: {
		Choosetype() {
			this.show = true;
			this.download = false;
			this.getStockDataForXls(3)
		},
		startDownload(){
		this.isLoadingforxls =true;
		},
		finishDownload(){
		this.isLoadingforxls =false;
		},
		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		getClientList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				warehouseid: this.warehouseid,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listClientData = result.data.data;
				}, error => {
					console.error(error);
				});
		},
		getWarehouseList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			this.input = ({
				clientid: this.clientid,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					// console.log(result.data.data);
					this.listWarehouseData = result.data.data;
				}, error => {
					console.error(error)
				})
		},
		clientSelected() {
			if (this.clientid != this.client) {
				this.clientid = this.client;
				if (this.user_type != 'warehouse_user') {
					this.listWarehouseData = []
					this.getWarehouseList();
					if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
						this.warehouse = this.warehouseid = '';
					} else {
						this.warehouse = ''
					}
				} else {
					if (this.warehouseid && this.clientid);
					// this.getStockData();
				}
			}
			this.listStockData = [];
			this.pageno = this.pageCount = 0;
		},

		warehouseSelected() {
			this.warehouseid = this.warehouse;
			this.pageno = this.pageCount = 0;
			if (this.warehouseid) {
				if (this.clientid) {
					// this.getStockData();
				} else {
					this.getClientList();
				}
			}
		},
		getStockDataSearch() {
      this.pageno = 0;
      this.pageCount = 0;
      this.searchFlag=true;
      this.getStockData(2);
    },
		//to get Stock list
		getStockData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};
			if (csvCheck == 2){
				this.show=false;
				this.download =true;
			}
			// this.ClientErr = '';
			if (this.clientid == '' || this.client == '') {
				this.ClientErr = 'Client is required';
				this.pageno = this.pageCount = 0;
				this.listStockData = [];
				return false;
			}
			if (this.warehouseid == '' || this.warehouse == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageno = this.pageCount = 0;
				this.listStockData = [];
				return false;
			}

			this.isLoading = true;

			this.input = ({
				offset: this.pageno,
				limit: 10,
				warehouseid: this.warehouseid,
				clientid: this.clientid,
				clientproductid: this.clientproductid,
				csvData: csvCheck,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
					})
			if (this.client != '') {
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getStockreportListclient',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {

							if (csvCheck == 1) {
								this.show = true;
								this.download = false;
								this.csvFields = {
									'warehouseid': this.$t('warehouseRacks.warehouseID'),
									'clientproductid': this.$t('srmaster.table.clientProductID'),
									'productname': this.$t('srmaster.table.productName'),
									'mrp':  this.$t('srqc.mrp'),
									'warehousestock': this.$t('editedjson.physicalStock'),
									'currentstock': this.$t('editedjson.logicalStock'),
									'uom': this.$t('common.uom'),
									'lastmodifieddate': this.$t('editedjson.lastUpdatedOn'),
								};
								var dateFilter = ['LastUpdatedOn'];
								var skipFilter = ['LastUpdatedOn'];
								this.listStockReportDataCsv = result.data.data;
								csvHelper.data.jsonToCSV(this.$t('editedjson.stockreportClient'), this.listStockReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

								// this.jsonToCSV('Stockreport', this.listStockReportDataCsv, this.csvFields, dateFilter, skipFilter);
							} else {
								this.listStockData = result.data.data;
								if (result.data.errorCode == -1) {
									this.resultCount = 0
								} else {
									this.totalRows = result.data.count;
									this.resultCount = result.data.count
									if (this.totalRows < 10) {
										this.pageCount = 1
									} else {
										this.pageCount = Math.ceil(this.totalRows / 10)
									}
								}
							}

							this.isLoading = false;
						},
						error => {
							console.error(error)
						})
			} else {
				this.ClientErr = 'Client is required';
			}
		},
		getStockDataForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			// this.ClientErr = '';


			this.input = ({
				offset: this.pageno,
				limit: 10,
				warehouseid: this.warehouseid,
				clientid: this.clientid,
				clientproductid: this.clientproductid,
				csvData: csvCheck,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			if (this.client != '') {
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getStockreportListclient',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						if (csvCheck == 3) {
								if (result.data.data.length > 0) {
									this.listReportDataforxls = [];
									this.csvFieldsForXls =[];
							this.csvFieldsForXls[this.$t('warehouseRacks.warehouseID')] = 'warehouseid',
							this.csvFieldsForXls[this.$t('srmaster.table.clientProductID')] ='clientproductid',
							this.csvFieldsForXls[this.$t('srmaster.table.productName')] = 'productname',
							this.csvFieldsForXls[this.$t('srqc.mrp')] = 'mrp',
							this.csvFieldsForXls[this.$t('editedjson.physicalStock')] = 'warehousestock',
							this.csvFieldsForXls[this.$t('editedjson.logicalStock')] = 'currentstock',
							this.csvFieldsForXls[this.$t('common.uom')] = 'uom',
							this.csvFieldsForXls[this.$t('editedjson.lastUpdatedOn')] ='lastmodifieddate',
								
									this.listReportDataforxls = result.data.data;
								}
								else {
										if (result.data.status == true) {
											this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
										} else {
											this.$alertify.error(result.data.msg.message);
										}
									}


						}



						},
						error => {
							console.error(error)
						})
			} else {
				this.ClientErr = 'Client is required';
			}
		},
		getClientList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;

			this.input = ({
				warehouseid: this.warehouseid,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listClientData = result.data.data;
				}, error => {
					console.error(error);
				});
		},
		//to reset search form
		resetForm() {
			this.show=false;
			this.download =true;
			this.clientproductid = '';
			this.pageno = this.pageCount = 0;
			this.listStockData = [];
			this.totalRows =0;
			this.searchFlag=false;
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
		},

		//to get Warehouse id list

		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD HH:mm:ss');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		//to paginate  stock List
		getPaginationData(pageNum) {
			this.pageno = (pageNum - 1) * 10
			this.getStockData()
		},


	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/stockreportclient/stockreportclient.component.js